import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import styles from './index.module.scss';
import { eventsGridActions } from 'containers/Pages/Events';
import { t } from 'i18next';

const ViewPublishedEvent = ({ id }) => {
  const dispatch = useDispatch();
  const disaptchFetchPublishedEvent = useCallback(
    id => {
      dispatch(eventsGridActions.fetchGridRowDetails({ id }));
    },
    [dispatch],
  );

  const onClickViewPublished = () => {
    disaptchFetchPublishedEvent(id);
  };

  return (
    <Button
      text={t('View Published')}
      className={styles.button}
      color={'secondary'}
      onClick={onClickViewPublished}
    />
  );
};

ViewPublishedEvent.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ViewPublishedEvent;
